import { render } from "./LandscapeManagement.vue?vue&type=template&id=80cf0a8e&scoped=true&ts=true"
import script from "./LandscapeManagement.vue?vue&type=script&lang=ts"
export * from "./LandscapeManagement.vue?vue&type=script&lang=ts"

import "./LandscapeManagement.vue?vue&type=style&index=0&id=80cf0a8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80cf0a8e"]])

export default __exports__